///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2022
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import { times } from "lodash";

function Loader() {
  const BodyCell = () => (
    <td className="body-cell content-placeholder py-16 px-8 align-middle">
      <span></span>
    </td>
  );

  return (
    <tbody data-testid="loader">
      {times(18, index => {
        return (
          <tr className="row bg-white" key={index}>
            {times(8, index => (
              <BodyCell key={index} />
            ))}
          </tr>
        );
      })}
    </tbody>
  );
}

export default Loader;
